import { render, staticRenderFns } from "./edit_label.vue?vue&type=template&id=4deecae8&scoped=true"
import script from "./edit_label.vue?vue&type=script&lang=js"
export * from "./edit_label.vue?vue&type=script&lang=js"
import style0 from "./edit_label.vue?vue&type=style&index=0&id=4deecae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deecae8",
  null
  
)

export default component.exports